<template>
  <div id="app" :class="$config.MODE">
    <transition name="fade" mode="out-in">
      <keep-alive v-bind:max="2">
        <router-view/>
      </keep-alive>
    </transition>
    <modal />
    <center-notifications />
  </div>
</template>

<script>
import persistentData from '@/plugins/persistentData'
import interceptor from '@/plugins/interceptor'
import Modal from '@/components/Modal/Modal.vue'
import CenterNotifications from '@/components/Notifications/CenterNotifications.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Modal,
    CenterNotifications
  },
  data() {
    return {
      intervalGames: null
    }
  },
  async created() {
    const token = persistentData.getData('token')
    const self = this

    if (token) {
      const expiration = await interceptor.validateToken()
      if (expiration && this.$route.path == '/') this.$router.push('/home/games')
      this.$store.dispatch('profileGet')
    } else if (this.$route.path != '/welcome' && this.$route.path != '/login' && this.$route.path != '/login/mail' && this.$route.path != '/redirect_login') {
      this.$router.push(`/welcome`)
    }


    // Clear localstorage
    if (self.$route.name != 'ScreenGame' && self.$route.name != 'ScreenGamePicture' && self.$route.name != 'ScreenGamePictureSuccess') {
      persistentData.clearDataGame()
    } else {
      self.gameLeave(self.$route.params.id)
    }

    if (self.$route.name == 'HomeGames') {
      self.intervalCallListGames()
    }

    window.addEventListener('popstate', function () {
      setTimeout(() => {
        // Back navigator to ScreenGamePictureSuccess, exit game
        if (self.$route.name == 'ScreenGamePictureSuccess') self.gameLeave(self.$route.params.idGame)
        // Back navigator to ScreenGame, redirect game
        if (self.$route.name == 'ScreenGamePicture') self.$router.push(`/game/${self.$route.params.idGame}`)
      }, 0)
    });

    // Fix navigation
    if(window["cordova"] != undefined) {
      window.open = window["cordova"].InAppBrowser.open;
    }
  },
  computed: {
    ...mapState({
      selectGame: state => state.InfoModule.selectGame
    })
  },
  methods: {
    gameLeave(idGame) {
      const dataGame = persistentData.getData(`game-${idGame}`,true)
      if ( dataGame ) {
        this.$store.dispatch('gameLeave', {
          gameId: dataGame.gameId,
          teamId: dataGame.teamId
        })
        this.$store.dispatch('destroyGameStat')
        this.$store.dispatch('destroyUserIsInGame')
    
        persistentData.removeData(`game-${idGame}`)
        this.$router.push('/home/games')
      } else {
        this.$store.dispatch('destroyGameStat')
        this.$store.dispatch('destroyUserIsInGame')
      }
    },
    intervalCallListGames() {
      if (this.intervalGames != null) {
        clearInterval(this.intervalGames)
        this.intervalGames = null
      }
      
      this.intervalGames = setInterval(() => {
        this.$store.dispatch('getPublishedGames')
      }, 10000) 
    }
  },
  watch: {
    "$route.name": function (value) {
      // Detect the departure of the match
      if (value != 'ScreenGame' && value != 'ScreenGamePicture' && value != 'ScreenGamePictureSuccess') {
        this.gameLeave(this.selectGame.id)
      }
      // Call list games in screen homeGames
      if (value == 'HomeGames') {
        this.intervalCallListGames()
      } else {
        clearInterval(this.intervalGames)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/main';
@import '@/styles/environment/SUPERLIGA/main';

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
